import { render } from "./release_poster.vue?vue&type=template&id=280d362e&scoped=true"
import script from "./release_poster.vue?vue&type=script&lang=js"
export * from "./release_poster.vue?vue&type=script&lang=js"

import "./release_poster.vue?vue&type=style&index=0&id=280d362e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280d362e"]])

export default __exports__